var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Viewport',{attrs:{"rootMargin":_vm.renderMargin},on:{"enter":_vm.play}},[_c('Viewport',{attrs:{"rootMargin":"10% 0% 10% 0%"},on:{"enter":_vm.reverse}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }